import UserRoleComponent from "../components/UserRole";
import useUserRole from "../hooks/useUserRole";

function UserRole() {
  const useUserRoleProps = useUserRole();
  return <UserRoleComponent {...useUserRoleProps} />;
}

export default UserRole;
